/* global axios */
import ApiClient from './ApiClient';

class AssistantAPI extends ApiClient {
  constructor() {
    super('assistant', { accountScoped: true });
  }

  getSettings() {
    return axios.get(`${this.url}/settings`);
  }

  updateSettings(settings) {
    return axios.put(`${this.url}/settings`, { settings });
  }

  getAnalytics() {
    return axios.get(`${this.url}/analytics`);
  }

  getDocuments() {
    return axios.get(`${this.url}/documents`);
  }

  createDocument({ sourceRef, text }) {
    return axios.post(`${this.url}/documents`, { source_ref: sourceRef, text });
  }

  deleteDocument({ sourceType, sourceRef }) {
    return axios.delete(`${this.url}/documents`, {
      params: { source_type: sourceType, source_ref: sourceRef },
    });
  }

  getDocumentContent({ sourceType, sourceRef }) {
    return axios.get(`${this.url}/documents/content`, {
      params: { source_type: sourceType, source_ref: sourceRef },
    });
  }

  getImages() {
    return axios.get(`${this.url}/images`);
  }

  // Multipart: the file goes to Rails storage, only its description and url
  // travel on to the brain.
  createImage({ description, file }) {
    const form = new FormData();
    form.append('description', description);
    form.append('file', file);
    return axios.post(`${this.url}/images`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  deleteImage(id) {
    return axios.delete(`${this.url}/images/${id}`);
  }

  getFaqs(status) {
    return axios.get(`${this.url}/faqs`, {
      params: status ? { status } : {},
    });
  }

  createFaq({ question, answer }) {
    return axios.post(`${this.url}/faqs`, { question, answer });
  }

  updateFaq({ id, question, answer }) {
    return axios.put(`${this.url}/faqs/${id}`, { question, answer });
  }

  deleteFaq(id) {
    return axios.delete(`${this.url}/faqs/${id}`);
  }

  approveFaq(id) {
    return axios.post(`${this.url}/faqs/${id}/approve`);
  }

  crawl(url, maxPages = null) {
    const body = { url };
    if (maxPages) body.max_pages = maxPages;
    return axios.post(`${this.url}/crawl`, body);
  }

  playground({ message, history }) {
    return axios.post(`${this.url}/playground`, { message, history });
  }

  suggestReply({ conversationId }) {
    return axios.post(`${this.url}/suggest_reply`, {
      conversation_id: conversationId,
    });
  }

  getInboxes() {
    return axios.get(`${this.url}/inboxes`);
  }

  toggleInbox({ inboxId, connected }) {
    return axios.post(`${this.url}/inboxes/${inboxId}/toggle`, { connected });
  }

  getTools() {
    return axios.get(`${this.url}/tools`);
  }

  createTool(tool) {
    return axios.post(`${this.url}/tools`, { tool });
  }

  updateTool(id, tool) {
    return axios.put(`${this.url}/tools/${id}`, { tool });
  }

  deleteTool(id) {
    return axios.delete(`${this.url}/tools/${id}`);
  }

  getGoogleStatus() {
    return axios.get(`${this.url}/google_oauth/status`);
  }

  getGoogleAuthorizeUrl() {
    return axios.get(`${this.url}/google_oauth/authorize`);
  }

  disconnectGoogle() {
    return axios.delete(`${this.url}/google_oauth`);
  }
}

export default new AssistantAPI();
